import { cn } from "@/lib/utils"

/** A workspace's logo tile: its first letter on `fill` (logo upload comes later). */
export function WorkspaceTile({
  name,
  size = 24,
  className,
}: {
  name: string
  size?: 20 | 24 | 32
  className?: string
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-control bg-fill font-semibold text-ink",
        size === 32 ? "text-sm" : "text-[12px]",
        className,
      )}
      style={{ width: size, height: size }}
    >
      {(name.trim()[0] ?? "?").toUpperCase()}
    </span>
  )
}
